/* Nelson method plate (2026-10-12). Design: canvas board "A · The Plate (inverted)".
 * Turns the PDP's one-line method chooser into an inverted Fence plate with four finish tiles,
 * and replaces the price card's "Logo print included" chip with a ticket stub that names the
 * placement and the method actually selected.
 *
 * Add-on, like nelson-price-card.js: piobox-pdp.js is untouched. It keeps the PDP's own method list
 * open (data-togglemethods) but hidden, reads names, prices and availability from those buttons,
 * and a tile click clicks the matching hidden [data-m] button, so the PDP stays the single source
 * of truth for price and method. Writes happen only when a value changes (the PDP and the price
 * card both observe the same subtree).
 *
 * DTG is shown disabled on polyester-rich garments: it prints dull and cracks there. */
(function () {
  "use strict";
  var ORDER = ["embroidery", "dtf", "screen", "dtg"];
  var COPY = {
    embroidery: { name: "Embroidery", line: "Stitched thread. Raised, premium, survives anything.", m: [3, 5, 2] },
    dtf: { name: "Digital transfer", line: "Full colour and photos. No setup fee.", m: [3, 4, 5] },
    screen: { name: "Screen print", line: "Ink pressed through a screen. Sharpest at volume.", m: [4, 5, 4] },
    dtg: { name: "Direct to garment", line: "Full colour straight onto cotton. Soft feel.", m: [5, 3, 4] }
  };
  var METERS = ["Soft feel", "Lasts", "Detail"];
  var HEX = {
    "airforce blue": "#5D7FA3", black: "#1A1A1A", bottle: "#1F4D36", burgundy: "#6B1F2E", "charcoal melange": "#4A4D50",
    emerald: "#11845B", "grey melange": "#A9ABAD", grey: "#A9ABAD", lime: "#9BCB3B", navy: "#1C2741", olive: "#5E6232",
    orange: "#E8692C", pink: "#EFA3BD", "powder blue": "#A9C7E3", purple: "#5A2E7A", red: "#C4232C", royal: "#2448A6",
    "slate grey": "#6C7680", stone: "#CFC2A8", turquoise: "#1FA3B5", white: "#FFFFFF", yellow: "#F4CC2E"
  };
  var SPARK = '<svg width="12" height="12" viewBox="0 0 10 10" aria-hidden="true"><path d="M2 2l1 1M7 7l1 1M8 2 2 8" stroke="#F0531C" stroke-width="2.4" stroke-linecap="round" fill="none"/></svg>';
  var PROOF = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 3h8.5L19 7.5V21H6z"/><path d="M14.5 3v4.5H19"/><path d="M9 14l2.25 2.25L16 11.5" stroke="#F0531C" stroke-width="2"/></svg>';

  var esc = function (s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); };
  var txt = function (el) { return el ? (el.textContent || "").replace(/\s+/g, " ").trim() : ""; };
  var cents = function (s) { var m = String(s).replace(/[\s ]/g, "").match(/R(\d+)(?:[.,](\d{1,2}))?/); return m ? Math.round(parseFloat(m[1] + "." + (m[2] || "0")) * 100) : null; };
  var setHTML = function (el, html) { if (el && el.__h !== html) { el.innerHTML = html; el.__h = html; } };

  function polyRich() {
    var c = window.__PBX_PDP__ || {};
    var s = ((c.specs || "") + " " + ((c.product && c.product.description) || "")).toLowerCase();
    return s.indexOf("polyester") >= 0 && s.indexOf("100% cotton") < 0;
  }

  function start() {
    var root = document.querySelector(".pbx-pdp [id^=pbx-pdp-]");
    if (!root) return;
    var poly = polyRich();
    var plate = null, stub = null, opening = false, t = null;

    function read() {
      var host = root.querySelector("[data-method]");
      if (!host) return null;
      var line = host.querySelector(".pbx-method-line");
      if (!line) return { host: host, empty: true };
      var toggle = host.querySelector("[data-togglemethods]");
      var opts = {};
      host.querySelectorAll(".pbx-m[data-m]").forEach(function (b) {
        opts[b.dataset.m] = {
          id: b.dataset.m,
          on: b.getAttribute("aria-checked") === "true",
          blocked: b.disabled,
          per: cents(txt(b.querySelector(".pbx-mp"))),
          why: txt(b.querySelector("small"))
        };
      });
      var current = Object.keys(opts).filter(function (k) { return opts[k].on; })[0];
      if (!current) {
        var name = txt(line.querySelector("span")).toLowerCase();
        ORDER.forEach(function (k) { if (!current && name.indexOf(COPY[k].name.toLowerCase()) === 0) current = k; });
      }
      var pos = [].slice.call(root.querySelectorAll(".pbx-layer .pbx-layer-name b")).map(txt).filter(Boolean);
      var colBtn = root.querySelector('[data-c][aria-pressed="true"]');
      return { host: host, toggle: toggle, opts: opts, current: current, pos: pos, colour: colBtn ? colBtn.dataset.c : "" };
    }

    function ensureOpen(s) {
      // The PDP lists every method with its price only while its chooser is open; keep it open, hidden.
      if (s.toggle && !Object.keys(s.opts).length && !opening) {
        opening = true;
        s.toggle.click();
        setTimeout(function () { opening = false; }, 120);
        return false;
      }
      return true;
    }

    function render() {
      var s = read();
      if (!s) return;
      if (s.empty) { if (plate) plate.hidden = true; renderStub(null); return; }
      if (!ensureOpen(s)) return;
      root.classList.add("nmp-on");

      if (!plate || !root.contains(plate)) {
        plate = document.createElement("section");
        plate.className = "nmp";
        plate.setAttribute("aria-labelledby", "nmp-h");
        s.host.insertAdjacentElement("afterend", plate);
        plate.addEventListener("click", function (e) {
          var b = e.target.closest("[data-nmp]");
          if (!b || b.disabled) return;
          var real = root.querySelector('.pbx-m[data-m="' + b.dataset.nmp + '"]');
          if (real && !real.disabled) real.click();
        });
      }
      plate.hidden = false;

      var ids = ORDER.filter(function (k) { return s.opts[k]; });
      var priced = ids.filter(function (k) { return !s.opts[k].blocked && s.opts[k].per != null && !(k === "dtg" && poly); });
      var best = priced.slice().sort(function (a, b) { return s.opts[a].per - s.opts[b].per; })[0];
      if (s.current === "dtg" && poly && best) {
        // Never leave a polyester garment on DTG, even if it was the PDP's pick.
        var swap = root.querySelector('.pbx-m[data-m="' + best + '"]');
        if (swap) { swap.click(); return; }
      }
      var hex = HEX[(s.colour || "").toLowerCase()] || "#5D7FA3";
      var cur = COPY[s.current] || COPY.dtf;

      var tiles = ids.map(function (k) {
        var o = s.opts[k], c = COPY[k];
        var off = o.blocked || (k === "dtg" && poly);
        var on = k === s.current && !off;
        var why = k === "dtg" && poly ? "Not on polyester. It prints dull and cracks." : o.blocked ? (o.why || "Needs a quote for this artwork.") : c.line;
        var price = off ? "—" : o.per != null ? "+R " + (o.per / 100).toFixed(2).replace(".", ",") : "";
        return '<button type="button" class="nmp-tile' + (on ? " is-on" : "") + '" role="radio" aria-checked="' + on + '" data-nmp="' + k + '"' + (off ? " disabled" : "") + ">" +
          '<span class="nmp-swatch" style="background:' + hex + '"><span class="nmp-logo nmp-tx-' + k + '">LOGO</span>' +
          (k === best && !off ? '<span class="nmp-tag">Best for this logo</span>' : "") +
          (on ? '<span class="nmp-check">' + SPARK + "</span>" : "") + "</span>" +
          '<span class="nmp-body"><span class="nmp-row"><b>' + esc(c.name) + '</b><span class="nmp-price">' + price + "</span></span><small>" + esc(why) + "</small></span></button>";
      }).join("");

      var meters = METERS.map(function (label, i) {
        var dots = "";
        for (var d = 1; d <= 5; d++) dots += '<i class="' + (d <= cur.m[i] ? "is-on" : "") + '"></i>';
        return '<div><span class="nmp-k">' + label + '</span><span class="nmp-dots" aria-label="' + label + " " + cur.m[i] + ' of 5">' + dots + "</span></div>";
      }).join("");

      setHTML(plate,
        '<div class="nmp-head"><div><span class="nmp-eyebrow">The finish</span><h3 id="nmp-h">How should we<br>brand it?</h3></div>' +
        '<span class="nmp-colour">Your logo,<br>on ' + esc(s.colour || "your colour") + "</span></div>" +
        '<div class="nmp-grid" role="radiogroup" aria-label="Branding method">' + tiles + "</div>" +
        '<div class="nmp-meters">' + meters + "</div>" +
        '<p class="nmp-proof">' + PROOF + "<span>Free proof first. Change the finish any time before you approve.</span></p>");

      renderStub({ pos: s.pos, name: cur.name });
    }

    function renderStub(d) {
      var card = root.querySelector(".nlp");
      if (!card) return;
      if (!d) { if (stub) stub.hidden = true; return; }
      if (!stub || !card.contains(stub)) {
        stub = document.createElement("div");
        stub.className = "nmp-stub";
        card.insertAdjacentElement("afterbegin", stub);
      }
      stub.hidden = false;
      var where = d.pos.length ? d.pos.join(" + ") : "";
      setHTML(stub, SPARK + '<span class="nmp-stub-k">Logo print included</span><span class="nmp-stub-v">' + esc(where ? where + " · " + d.name : d.name) + "</span>");
    }

    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var n = list[i].target;
        if (!(plate && plate.contains(n)) && !(stub && stub.contains(n))) { clearTimeout(t); t = setTimeout(render, 60); return; }
      }
    }).observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ["aria-pressed", "aria-checked", "hidden"] });
    render();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { setTimeout(start, 0); });
  else setTimeout(start, 0);
})();
